<div class="relative" data-date-picker [class.ng-invalid]="isInvalid">
  <div
    #triggerButton
    class="flex w-full items-center rounded-[6px] border border-slate300 bg-slate50 px-2 text-sm transition"
    [ngClass]="{
      'h-9': size === 'sm',
      'h-10': size === 'md',
      'h-[46px]': size === 'lg',
      'cursor-not-allowed opacity-70': control?.disabled || startControl?.disabled,
      '!border-red500': isInvalid
    }">
 
    <!-- Calendar icon sits on the left of the date, matching currency fields. -->
    <button
      type="button"
      (click)="toggle()"
      class="mr-2 mt-1 inline-flex shrink-0 cursor-pointer items-center text-slate400 hover:text-slate600 outline-none disabled:cursor-not-allowed"
      aria-label="Toggle calendar"
      [disabled]="!!control?.disabled || !!startControl?.disabled"
    >
      <app-icon-reusable
        [icon]="calenderIcon"
        [size]="computedIconSize"
        classes="shrink-0"
      ></app-icon-reusable>
    </button>

    @if (mode === 'single') {
      <input
        type="text"
        class="min-w-0 flex-1 bg-transparent !text-sm outline-none"
        [ngClass]="(control?.value || rawSingle) ? 'text-slate800' : 'text-slate400'"
        [placeholder]="placeholder"
        [disabled]="!!control?.disabled"
        autocomplete="off"
        [value]="singleDisplayValue"
        (focus)="onSingleFocus()"
        (keydown)="onDateKeydown($event)"
        (input)="onSingleInput($event)"
        (blur)="onSingleBlur($any($event.target).value)"
      />
    }

    @if (mode === 'range') {
      <input
        type="text"
        class="range-date min-w-0 shrink bg-transparent !text-xs outline-none"
        [ngClass]="(startControl?.value || rawStart) ? 'text-slate900' : 'text-slate400'"
        placeholder="dd-mm-yyyy"
        [disabled]="!!startControl?.disabled"
        autocomplete="off"
        [value]="startDisplayValue"
        (focus)="onStartFocus()"
        (keydown)="onDateKeydown($event)"
        (input)="onStartInput($event)"
        (blur)="onStartBlur($any($event.target).value)"
      />
      <!-- Each date fits its text, so the dash sits centred in a small, even gap between them. -->
      <span class="mx-1.5 shrink-0 text-slate400">–</span>
      <input
        type="text"
        class="range-date min-w-0 shrink bg-transparent !text-xs outline-none"
        [ngClass]="(endControl?.value || rawEnd) ? 'text-slate900' : 'text-slate400'"
        placeholder="dd-mm-yyyy"
        [disabled]="!!startControl?.disabled"
        autocomplete="off"
        [value]="endDisplayValue"
        (focus)="onEndFocus()"
        (keydown)="onDateKeydown($event)"
        (input)="onEndInput($event)"
        (blur)="onEndBlur($any($event.target).value)"
      />
    }

  </div>
 
  @if (isOpen) {
  <div
    class="z-[9999] overflow-hidden rounded-[8px] border border-slate300 bg-white shadow-[0_6px_16px_rgba(15,23,42,0.18)]"
    [ngStyle]="overlayStyle"
  >
    <div class="p-3" [ngClass]="{ 'flex items-start gap-4': rangeSideBySide }">
      <div class="min-w-0 flex-1">
      <div class="mb-3 flex items-center justify-between px-1">
        <button type="button" (click)="prevMonth('left')" class="inline-flex h-7 w-7 items-center justify-center rounded-full text-slate500 hover:bg-slate50">‹</button>
 
        <div class="flex items-center gap-2">
          <select class="h-8 rounded-md border border-slate300 bg-white px-2 text-xs text-slate700 outline-none" (change)="onMonthChange('left',$any($event.target).value)">
            @for (m of monthOptions; track m.value) {
              <option [value]="m.value" [selected]="m.value === leftMonth.getMonth()">{{ m.label }}</option>
            }
          </select>

          <select class="h-8 rounded-md border border-slate300 bg-white px-2 text-xs text-slate700 outline-none" (change)="onYearChange('left',$any($event.target).value)" (wheel)="onYearWheel('left', $event)">
            @for (y of yearOptions; track y) {
              <option [value]="y" [selected]="y === leftMonth.getFullYear()" [class.bg-slate200]="y === currentYear" [class.font-semibold]="y === currentYear">{{ y }}</option>
            }
          </select>
        </div>
 
        <button type="button" (click)="nextMonth('left')" [disabled]="isNextMonthDisabled(leftMonth)" class="inline-flex h-7 w-7 items-center justify-center rounded-full text-slate500 hover:bg-slate50 disabled:cursor-not-allowed disabled:opacity-30">›</button>
      </div>
 
      <div class="mb-2 grid grid-cols-7 gap-y-2">
        @for (d of weekDays; track $index) {
          <span class="text-center text-sm font-semibold text-slate700">{{ d }}</span>
        }
      </div>

      <div class="grid grid-cols-7 gap-y-1">
        @for (day of getCalendarDays(leftMonth); track day.iso) {
          <button type="button" (mousedown)="$event.preventDefault()" (click)="selectDate(day.iso)" [disabled]="isDateDisabled(day.iso)" class="mx-auto inline-flex h-9 w-9 items-center justify-center rounded-full" [ngClass]="{ 'text-slate400 opacity-70': !day.inCurrentMonth && !isSelected(day.iso), 'text-slate700': day.inCurrentMonth && !isSelected(day.iso) && !isDateDisabled(day.iso), 'bg-slate200 text-slate900': isSelected(day.iso), 'bg-indigo100 text-indigo700': mode === 'range' && isInRange(day.iso), 'cursor-not-allowed !text-slate300 opacity-40': isDateDisabled(day.iso) }">{{ day.day }}</button>
        }
      </div>
      </div>

      @if (mode === 'range') {
      <div class="min-w-0 flex-1" [ngClass]="rangeSideBySide ? 'border-l border-slate200 pl-4' : 'mt-3'">
        <div class="mb-3 flex items-center justify-between px-1">
          <button type="button" (click)="prevMonth('right')" class="inline-flex h-7 w-7 items-center justify-center rounded-full text-slate500 hover:bg-slate50">‹</button>
 
          <div class="flex items-center gap-2">
            <select class="h-8 rounded-md border border-slate300 bg-white px-2 text-xs text-slate700 outline-none" (change)="onMonthChange('right',$any($event.target).value)">
              @for (m of monthOptions; track m.value) {
                <option [value]="m.value" [selected]="m.value === rightMonth.getMonth()">{{ m.label }}</option>
              }
            </select>

            <select class="h-8 rounded-md border border-slate300 bg-white px-2 text-xs text-slate700 outline-none" (change)="onYearChange('right',$any($event.target).value)" (wheel)="onYearWheel('right', $event)">
              @for (y of yearOptions; track y) {
                <option [value]="y" [selected]="y === rightMonth.getFullYear()" [class.bg-slate200]="y === currentYear" [class.font-semibold]="y === currentYear">{{ y }}</option>
              }
            </select>
          </div>
 
          <button type="button" (click)="nextMonth('right')" [disabled]="isNextMonthDisabled(rightMonth)" class="inline-flex h-7 w-7 items-center justify-center rounded-full text-slate500 hover:bg-slate50 disabled:cursor-not-allowed disabled:opacity-30">›</button>
        </div>
 
        <div class="mb-2 grid grid-cols-7 gap-y-2">
          @for (d of weekDays; track $index) {
            <span class="text-center text-sm font-semibold text-slate700">{{ d }}</span>
          }
        </div>

        <div class="grid grid-cols-7 gap-y-1">
          @for (day of getCalendarDays(rightMonth); track day.iso) {
          <button type="button" (mousedown)="$event.preventDefault()" (click)="selectDate(day.iso)" [disabled]="isDateDisabled(day.iso)" class="mx-auto inline-flex h-9 w-9 items-center justify-center rounded-full" [ngClass]="{ 'text-slate400 opacity-70': !day.inCurrentMonth && !isSelected(day.iso), 'text-slate700': day.inCurrentMonth && !isSelected(day.iso) && !isDateDisabled(day.iso), 'bg-slate200 text-slate900': isSelected(day.iso), 'bg-indigo100 text-indigo700': isInRange(day.iso), 'cursor-not-allowed !text-slate300 opacity-40': isDateDisabled(day.iso) }">{{ day.day }}</button>
          }
        </div>

        <div class="mt-3 flex items-center justify-between">
          <button type="button" class="text-sm text-slate500" (click)="clearRange($event)">Clear</button>
          <div class="text-xs text-slate500">Select start and end dates</div>
        </div>
      </div>
      }
    </div>
  </div>
  }
</div>